import type { PropsWithChildren } from 'react';

import { Col, Row } from 'antd';
import { Color } from 'src/styles';

import { BacklinkButton } from '../../Miscellaneous/BacklinkButton/BacklinkButton';
import { MTypography } from '../../MTypography/MTypography';

import * as Styles from './MyAccountLayout.styles';
import { MyAccountSidebar, MyAccountSidebarMenuItemKey } from './MyAccountSidebar';

export interface MyAccountLayoutProps {
  title?: string;
  backlink?: { to: string; label: string };
  sidebarMenuItemKey: MyAccountSidebarMenuItemKey;
  testId?: string;
}

export const MyAccountLayout = ({
  title,
  children,
  sidebarMenuItemKey,
  backlink,
  testId,
}: PropsWithChildren<MyAccountLayoutProps>) => {
  return (
    <Row>
      <MyAccountSidebar menuItemKey={sidebarMenuItemKey} />
      <Col span={16} sm={24} xs={24} md={15} lg={16}>
        {backlink && (
          <div className={Styles.backlinkButtonContainer}>
            <BacklinkButton to={backlink.to} label={backlink.label} />
          </div>
        )}
        <div className={Styles.mainContainer}>
          {title && (
            <div className={Styles.title({ hasBacklink: Boolean(backlink) })}>
              <MTypography variant='h4' weight='normal' color={Color.Brand6} testId={testId + '-title-section'}>
                {title}
              </MTypography>
            </div>
          )}
          {children}
        </div>
      </Col>
    </Row>
  );
};
